module.exports = __webpack_public_path__ + "static/img/request-demo.8289295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/request-demo.png
// module id = o5pv
// module chunks = 3